import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import FacilityActivationService from "services/Setup/LoanOrigination/FacilityActivation/FacilityActivationService";
import { notification } from "antd";

// Initial state
export const initialState = {
  loading: false,
  message: "",
  statusRespon: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  facilityActivationList: [],
};

// Thunk: Get Facility Activation List
export const getFacilityActivationSlice = createAsyncThunk(
  "FacilityActivation/getFacilityActivationSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await FacilityActivationService.getFacilityActivationService(userInput);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Unexpected error!");
    }
  }
);

export const getPrintSlice = createAsyncThunk(
  "FacilityActivation/getPrintSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await FacilityActivationService.getPrintService(userInput);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Unexpected error!");
    }
  }
);

// Thunk: Save Facility Activation
export const saveFacilityActivationSlice = createAsyncThunk(
  "FacilityActivation/saveFacilityActivationSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await FacilityActivationService.addFacilityActivationService(userInput);

      if (response.status === 200) {
        const data = response.data;
        if (data.status === "Success") {
          notification.success({
            message: data.status,
            description: data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: data.status,
            description: data.message,
            duration: 3,
          });
        }
        return data;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Unexpected error!");
    }
  }
);

// Slice
const FacilityActivation = createSlice({
  name: "facilityActivation",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetState: (state) => {
      state.loading = false;
      state.message = "";
      state.statusRespon = "";
      state.showMessage = false;
      state.redirect = "";
      state.result = {};
      state.facilityActivationList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Get facility activation list
      .addCase(getFacilityActivationSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFacilityActivationSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.facilityActivationList = action.payload || [];
        state.statusRespon = "Success";
      })
      .addCase(getFacilityActivationSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      // 
      .addCase(getPrintSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPrintSlice.fulfilled, (state, action) => {
        console.log('getPrintSlice',action);
        
        state.loading = false; 
        state.statusRespon = "Success";
      })
      .addCase(getPrintSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusRespon = "Error";
      })

      // Save facility activation
      .addCase(saveFacilityActivationSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveFacilityActivationSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message;
        // state.statusRespon = action.payload?.status || "Success";
        state.statusRespon = 200;
        state.redirect = "/";
      })
      .addCase(saveFacilityActivationSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusRespon = "Error";
        state.message = action.payload?.message || "Failed to save data.";
      });
  },
});

// Exports
export const {
  showNotification,
  hideNotification,
  showLoading,
  resetState,
} = FacilityActivation.actions;

export default FacilityActivation.reducer;
